// extracted by mini-css-extract-plugin
module.exports = {"predictionSummaryTableRoot":"ZZgBtCCI","tableStyled":"EuxqJeJk","numericalTableCell":"L3jw4VwY"};